import { UnstyledButton } from '@ardoq/button';
import { DropdownFooterActionSpace } from '@ardoq/dropdown-menu-ui';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale, t } from '@ardoq/i18n';

export const SelectAllFooter = ({
  onSelectAll,
  optionsCount,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: {
  onSelectAll: () => void;
  optionsCount: number;
  i18nLocale?: I18nLocale;
}) => (
  <UnstyledButton style={{ width: '100%' }} onClick={onSelectAll}>
    <DropdownFooterActionSpace justify="end">
      {t(
        i18nLocale,
        'select:selectAll',
        { count: optionsCount },
        'Select all ({{count}})'
      )}
    </DropdownFooterActionSpace>
  </UnstyledButton>
);
